import { useState } from "react";

const details = [
  ["Names and nicknames", "The ones only family uses."],
  ["Inside jokes", "The ones nobody else gets."],
  ["Meaningful places", "Where it all happened."],
  ["Photographs", "Up to 10 of yours, placed in the story."],
  ["Chapter titles", "Named by you, or shaped for you."],
  ["A dedication", "The first page, in your words."],
];
export const LittleDetails = () => {
  const [active, setActive] = useState(0);
  const M = ({ i, children }) => <mark data-active={active === i} data-testid={`detail-mark-${i}`}>{children}<sup>{String(i + 1).padStart(2, "0")}</sup></mark>;
  return <section className="details-section" aria-labelledby="details-title" data-testid="little-details">
    <div className="brand-container details-grid">
      <h2 id="details-title" className="display-l details-title">The details only <em>you’d know.</em></h2>
      <ul className="details-list" data-testid="details-list">
        {details.map(([title, note], i) => <li key={title}>
          <button type="button" aria-pressed={active === i} onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onClick={() => setActive(i)} data-testid={`detail-${i}`}>
            <span className="details-num">{String(i + 1).padStart(2, "0")}</span><span><strong>{title}</strong><small>{note}</small></span>
          </button>
        </li>)}
      </ul>
      <figure className="details-figure">
        <div className="details-page" data-testid="details-sample-page">
          <p className="details-kicker">Opening dedication</p>
          <p className="details-salutation"><M i={5}>For Amma,</M></p>
          <p>who still calls me <M i={0}>Kutti</M>, even now that I’m taller than her. For <M i={1}>“just one more episode”</M>, which never was. For the evenings on <M i={2}>the Besant Nagar terrace</M>, and for <M i={3}>the photo of us at Egmore station</M> that still lives in my wallet.</p>
          <p className="details-sign">With love, Meera</p>
          <p className="details-next"><M i={4}>Chapter three. The Biscuit Tin Years</M></p>
        </div>
        <figcaption>An example page. Every book is written from your own answers.</figcaption>
      </figure>
    </div>
  </section>;
};
